import React, { FC } from 'react';
import {
	AWARD_STATUS_DISPLAY_BACKGROUND_COLORS,
	AWARD_STATUS_DISPLAY_NAMES,
	AWARD_STATUS_DISPLAY_TEXT_COLORS,
} from '../../constants/BidderStatuses';

const AwardStatusDisplay: FC<any> = ({ awardStatus }): React.ReactElement => {
	if (!awardStatus) {
		return null;
	}

	const statusColor = AWARD_STATUS_DISPLAY_TEXT_COLORS[awardStatus];
	const statusBackgroundColor = AWARD_STATUS_DISPLAY_BACKGROUND_COLORS[awardStatus];
	const statusDisplayName = AWARD_STATUS_DISPLAY_NAMES[awardStatus];

	return (
		<span
			style={{
				color: statusColor,
				background: statusBackgroundColor,
				padding: '4px 12px',
				borderRadius: 16,
				whiteSpace: 'nowrap',
			}}
		>
			{statusDisplayName}
		</span>
	);
};

export default AwardStatusDisplay;
